module.exports = __webpack_public_path__ + "img/business.3402beb0.jpg";